import i18n from "../../../i18n";
import { Notification } from "../../../Utils/Notification";

export const clearState = (state, action, initialState) => {
  return { ...state, [action.stateName]: initialState[action.stateName] };
};

export const cacheAddPlan = (state, action) => {
  return {
    ...state,
    cacheDialogValue: {
      ...state.cacheDialogValue,
      [action.key]: action.value,
    },
  };
};

export const togglesocketIsListeningToPlanningTable = (state, action) => {
  return { ...state, socketIsListeningToPlanningTable: action.state };
};

export const getPlans = (state, action) => {
  const updateValue = {
    request: action.query,
    error: null,
  };
  return { ...state, Plans: { ...state.Plans, ...updateValue } };
};

export const getPlansSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  return { ...state, Plans: updateValue };
};

export const getPlansFail = (state, action) => {
  const updateValue = {
    request: null,
    error: action.error,
  };
  return { ...state, Plans: { ...state.Plans, ...updateValue } };
};

export const createPlan = (state, action) => {
  const updateValue = {
    request: action.plan,
    response: null,
    error: null,
  };
  return { ...state, NewPlan: updateValue };
};

export const createPlanSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  return { ...state, NewPlan: updateValue };
};

export const createPlanFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error",
    4000
  );
  return { ...state, NewPlan: updateValue };
};

export const updatePlan = (state, action) => {
  const updateValue = {
    request: action.plan,
    response: null,
    error: null,
  };
  return { ...state, UpdatePlan: updateValue };
};

export const updatePlanSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  return { ...state, UpdatePlan: updateValue };
};

export const updatePlanFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, UpdatePlan: updateValue };
};

export const errorPlan = (state, action) => {
  const updateValue = {
    request: action.id,
    response: null,
    error: null,
  };
  return { ...state, ErrorPlan: updateValue };
};

export const errorPlanSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  return { ...state, ErrorPlan: updateValue };
};

export const errorPlanFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, ErrorPlan: updateValue };
};

export const downloadOptimizePlan = (state, action) => {
  const updateValue = {
    request: action.plan,
    response: null,
    error: null,
  };
  return { ...state, DownloadPlan: updateValue };
};

export const downloadOptimizePlanSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  return { ...state, DownloadPlan: updateValue };
};

export const downloadOptimizePlanFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, DownloadPlan: updateValue };
};

export const downloadExcelPlan = (state, action) => {
  const updateValue = {
    request: action.plan,
    response: null,
    error: null,
  };
  return { ...state, DownloadExcelPlan: updateValue };
};

export const downloadExcelPlanSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  return { ...state, DownloadExcelPlan: updateValue };
};

export const downloadExcelPlanFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, DownloadExcelPlan: updateValue };
};

export const downloadPlanForm = (state, action) => {
  const updateValue = {
    request: action.plan,
    response: null,
    error: null,
  };
  return { ...state, DownloadPlanForm: updateValue };
};

export const downloadPlanFormSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  return { ...state, DownloadPlanForm: updateValue };
};

export const downloadPlanFormFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );
  return { ...state, DownloadPlanForm: updateValue };
};

export const deletePlan = (state, action) => {
  const updateValue = {
    request: action.id,
    response: null,
    error: null,
  };
  return { ...state, DeletePlan: updateValue };
};

export const deletePlanSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  return { ...state, DeletePlan: updateValue };
};

export const deletePlanFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };

  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error",
    4000
  );
  return { ...state, DeletePlan: updateValue };
};

export const getPlanLogs = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, PlanLogs: updateValue };
};

export const getPlanLogsSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res?.entity || [],
    error: null,
  };
  return { ...state, PlanLogs: updateValue };
};

export const getPlanLogsFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };

  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error",
    4000
  );
  return { ...state, PlanLogs: updateValue };
};

export const restorePlan = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, restorePlan: updateValue };
};
export const restorePlanSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl" ? action.res?.messageFa : action.res?.message,
    "success"
  );
  return { ...state, restorePlan: updateValue };
};
export const restorePlanFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );
  return { ...state, restorePlan: updateValue };
};

export const getPlanIntegration = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, getIntegrationState: updateValue };
};
export const getPlanIntegrationSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res?.entity,
    error: null,
  };
  return { ...state, getIntegrationState: updateValue };
};
export const getPlanIntegrationFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
    Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );

  return { ...state, getIntegrationState: updateValue };
};

export const sendPlanIntegration = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, sendIntegrationState: updateValue };
};
export const sendPlanIntegrationSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl" ? action.res?.messageFa : action.res?.message,
    "success"
  );
  return { ...state, sendIntegrationState: updateValue };
};
export const sendPlanIntegrationFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );
  return { ...state, sendIntegrationState: updateValue };
};

export const restoreDriver = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, RestoreDriver: updateValue };
};
export const restoreDriverSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl" ? action.res?.messageFa : action.res?.message,
    "success"
  );
  return { ...state, RestoreDriver: updateValue };
};
export const restoreDriverFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );
  return { ...state, RestoreDriver: updateValue };
};

export const getFromExternalSource = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, ExternalPlan: updateValue };
};
export const getFromExternalSourceSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: { data: action.res, name: action.name },
    error: null,
  };
  return { ...state, ExternalPlan: updateValue };
};
export const getFromExternalSourceFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );
  return { ...state, ExternalPlan: updateValue };
};

export const getToolNameList = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, ToolnameList: updateValue };
};
export const getToolNameListSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res?.entity,
    error: null,
  };
  return { ...state, ToolnameList: updateValue };
};
export const getToolNameListFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );
  return { ...state, ToolnameList: updateValue };
};

export const postPlanConfig = (state, action) => {
  const updateValue = {
    request: action.config,
    response: null,
    error: null,
  };
  return { ...state, PostPlanConfig: updateValue };
};
export const postPlanConfigSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  return { ...state, PostPlanConfig: updateValue };
};
export const postPlanConfigFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, PostPlanConfig: updateValue };
};

export const executePlan = (state, action) => {
  const updateValue = {
    request: action.plan,
    response: null,
    error: null,
  };
  return { ...state, ExecutePlan: updateValue };
};

export const executePlanSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  return { ...state, ExecutePlan: updateValue };
};

export const executePlanFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );
  return { ...state, ExecutePlan: updateValue };
};

export const MissionInfoById = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, MissionInfoById: updateValue };
};

export const MissionInfoByIdSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res?.entity,
    error: null,
  };
  return { ...state, MissionInfoById: updateValue };
};

export const MissionInfoByIdFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );
  return { ...state, MissionInfoById: updateValue };
};

export const getAllPlansList = (state, action) => {
  const updateValue = {
    request: action.plan,
    response: null,
    error: null,
  };
  return { ...state, AllPlansList: { ...state.Plans, ...updateValue } };
};

export const getAllPlansListSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  return { ...state, AllPlansList: updateValue };
};

export const getAllPlansListFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, AllPlansList: updateValue };
};


export const deleteKpiState = (state, action) => {
  const updateValue = {
    request: action,
    response: null,
    error: null,
  };
  return { ...state, DeleteKpiState: { ...state.Plans, ...updateValue } };
};

export const deleteKpiStateSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action,
    error: null,
  };
  Notification.pushNotif(
      i18n.dir() === "rtl"
          ? "با موفقیت حذف شد"
          : "Deleted",
      "success",
      4000
  );
  return { ...state, DeleteKpiState: updateValue };
};

export const deleteKpiStateFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
      i18n.dir() === "rtl"
          ? action.error.response?.data?.messageFa
          : action.error.response?.data?.message,
      "error",
      4000
  );
  return { ...state, DeleteKpiState: updateValue };
};
